import React from 'react';
import ReactDOM from 'react-dom';
import 'i18n/index';
import App from './App';

// eslint-disable-next-line prettier/prettier
ReactDOM.render(<App />, document.getElementById('root'));
